export const EXSBVATRATE_SHOW_RESET = 'EXSBVATRATE_SHOW_RESET'
export const EXSBVATRATE_SHOW_SET_ERROR = 'EXSBVATRATE_SHOW_SET_ERROR'
export const EXSBVATRATE_SHOW_SET_RETRIEVED = 'EXSBVATRATE_SHOW_SET_RETRIEVED'
export const EXSBVATRATE_SHOW_TOGGLE_LOADING = 'EXSBVATRATE_SHOW_TOGGLE_LOADING'
